import TagManager from 'react-gtm-module';
import {IS_CLIENT, REGION} from '../../constant';
import {IRegion} from '../../type';
import {assert} from '../assert';

// 참고: https://docs.google.com/spreadsheets/d/1UImqaYvrEpFHBmDg5J7bWt8yRY8d8xffTcBuNxNoYDU/edit?ts=60d3f81d#gid=1332317610
const GTM_ID: {[region in IRegion]?: string} = {
  kor: 'GTM-TZR3GBZ',
  twn: 'GTM-NTQQPTJ',
  tha: 'GTM-MVNL3SM',
  idn: 'GTM-PXNR96B',
};

let isInit = false;
export function initGtm() {
  assert(IS_CLIENT, '클라이언트에서 실행되어야합니다.');

  init();
}

type IGtmEvent =
  | 'CONTENT_VIEW'
  | 'EVENT_NAME_TICKETPURCHASED'
  | 'COMPLETE_REGISTRATION';

export function sendGtmEvent(
  eventName: IGtmEvent,
  params?: {[key: string]: any}
) {
  if (isInit) {
    window.dataLayer.push({event: eventName, ...params});
  }
}

function init() {
  if (isInit) return;

  // prod는 별도로 처리하지 않는다.
  // 전체적인 추이만 보기 위함이라 테스트 데이터가 포함되어도 큰 영향이 없어 괜찮다 by wung
  const gtmId = GTM_ID[REGION];
  if (gtmId) {
    TagManager.initialize({gtmId});
    isInit = true;
  }
}
